module.exports = __webpack_public_path__ + "media/public/images/logo-small-34f45ca0a0df4f1ec36bf78adff2f373.svg";